module.exports = __webpack_public_path__ + "img/fujitsu-logo-color.e93ec2a9.png";